/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Tlm_0Inputs */

const en_svc_mvp_sprint_tlm_0 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sprint_length`)
};

const ar_svc_mvp_sprint_tlm_0 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدة السباق`)
};

const bn_svc_mvp_sprint_tlm_0 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্প্রিন্ট দৈর্ঘ্য`)
};

const de_svc_mvp_sprint_tlm_0 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint-Länge`)
};

const es_svc_mvp_sprint_tlm_0 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración del sprint`)
};

const fr_svc_mvp_sprint_tlm_0 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée du sprint`)
};

const pt_svc_mvp_sprint_tlm_0 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração do sprint`)
};

const zh_svc_mvp_sprint_tlm_0 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冲刺周期`)
};

const tr_svc_mvp_sprint_tlm_0 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint süresi`)
};

const ru_svc_mvp_sprint_tlm_0 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Длина спринта`)
};

const pl_svc_mvp_sprint_tlm_0 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Długość sprintu`)
};

/**
* | output |
* | --- |
* | "sprint_length" |
*
* @param {Svc_Mvp_Sprint_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_tlm_0 = /** @type {((inputs?: Svc_Mvp_Sprint_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_tlm_0(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_tlm_0(inputs)
	if (locale === "de") return de_svc_mvp_sprint_tlm_0(inputs)
	if (locale === "es") return es_svc_mvp_sprint_tlm_0(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_tlm_0(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_tlm_0(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_tlm_0(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_tlm_0(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_tlm_0(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_tlm_0(inputs)
	return en_svc_mvp_sprint_tlm_0(inputs)
});
export { svc_mvp_sprint_tlm_0 as "svc_mvp-sprint_tlm_0" }